<template>
  <v-container v-if="production" class="animate__animated animate__fadeInUp">
    <DetailsProductHeader :create_date="create_date" :production="production" />
    <v-divider class="my-2"></v-divider>
    <p class="text-caption mb-2">Results</p>
    <v-row>
      <v-col
        v-for="chart in production.charts"
        cols="12"
        md="6"
        :key="chart._id"
      >
        <DetailsChartCard :chart="chart" :cell="production.coordinates" :production="production" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <p class="text-caption mb-1">Sources</p>
        <DetailsSourceCard
          v-for="(source, index) in production.SourcesList"
          :key="source.token || index"
          :source="source"
          :production="production"
        />
      </v-col>
      <v-col cols="12" md="8">
        <p class="text-caption mb-1">Geometries</p>
        <DetailsGeometryCard :geometries="production.GeometryList" :production="production" />
      </v-col>
    </v-row>
  </v-container>
  <div class="containerLoading" v-else>
    <v-row justify="center" align="center" class="fill-height">
      <v-progress-circular
        :size="100"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import api from "@/services/api";
import Swal from "sweetalert2";
import DetailsSourceCard from "@/components/DetailsSourceCard";
import DetailsGeometryCard from "@/components/DetailsGeometryCard";
import DetailsProductHeader from "@/components/DetailsProductHeader";
import DetailsChartCard from "@/components/DetailsChartCard";
export default {
  name: "SimulationDetails",
  data: () => ({
    production: null,
    _id: null,
    create_date: null
  }),
  components: {
    DetailsGeometryCard,
    DetailsSourceCard,
    DetailsProductHeader,
    DetailsChartCard
  },
  methods: {
    fireError: message => {
      Swal.fire({ title: "An error occurred", text: message });
    },
    searchProductionFromSimulation: async function() {
      try {
        const { simulationID, productionID } = this.$route.params;
        const url = `/${simulationID}/productions/${productionID}`;
        const { data } = await api.get(url);

        // Simulação ou produção excluída: o backend responde { error: true } sem mensagem
        if (!data || data.error || !data.productions || !data.productions.length) {
          throw new Error(data && data.message ? data.message : "Production not found. It may have been deleted.");
        }
        this.production = JSON.parse(await data.productions[0].content);
        this._id = await data.productions[0]._id;
        this.create_date = await data.productions[0].create_date;
        this.setPageInfo();
      } catch (err) {
        this.fireError(err.message);
        this.$router.push("/dashboard").catch(() => {});
      }
    },
    setPageInfo: function() {
      document.title = this.production.title + " - ElectrosFI";
      document
        .querySelector('meta[name="description"')
        ?.setAttribute("content", this.production.title.description);
    }
  },
  mounted() {
    this.searchProductionFromSimulation();
  }
};
</script>
<style>
.containerLoading {
  height: 100%;
}
</style>
